const EDGE_DEFINITION_PATH: string = '/edges';

export const EDGE_DEFINITION_PATHS = {
    LANDING_PAGE: EDGE_DEFINITION_PATH,
    CREATE_NEW_EDGE_DEFINITION: `${EDGE_DEFINITION_PATH}/new`,
    UPDATE_EDGE_DEFINITION: `${EDGE_DEFINITION_PATH}/:id`,
};
